import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';
import Spinner from '@/components/common/Spinner';

const ColorButtonComponent = ({ children, color, disabled, isBusy, isDone, onClick, className: extraClassName, type, ...rest }) => {
  // Merge incoming className with internal classes and avoid props clobbering
  // so callers can pass utility overrides like "!m-0" safely.
  const colorClasses = {
    blue: 'bg-[#5882C1] hover:opacity-85 disabled:bg-[#5882C1]/75',
    green: 'bg-[#97A41F] hover:opacity-85 disabled:bg-[#97A41F]/75',
    red: 'bg-[#C90B0B] hover:opacity-85 disabled:bg-[#C90B0B]/75',
    gray: 'bg-[#C1C1C1] hover:opacity-85 disabled:bg-[#C1C1C1]/75',
  };
  const finalClassName = cn(
    'relative inline-flex justify-center items-center min-w-[140px] h-[36px] mx-2 px-[1.2em] !rounded-[3px] border-0 text-white font-bold text-[0.9375em] leading-[1.4] transition-all duration-300 select-none',
    colorClasses[color] || 'bg-[#C1C1C1] hover:opacity-85',
    (disabled || isBusy || isDone) && 'cursor-not-allowed opacity-75',
    extraClassName
  );

  return (
    <button
      className={finalClassName}
      type={type || 'button'}
      onClick={onClick}
      disabled={disabled || isBusy || isDone}
      {...rest}
    >
      {isBusy ? (
        <div className="w-auto h-[66%] flex items-center justify-center">
          <Spinner color="inherit" className="!m-0 text-white/80" />
        </div>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </button>
  );
};

ColorButtonComponent.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  isBusy: PropTypes.bool,
  isDone: PropTypes.bool,
  onClick: PropTypes.func,
};

ColorButtonComponent.defaultProps = {
  color: null,
  disabled: false,
  isBusy: false,
  isDone: false,
  onClick: null,
};

export default ColorButtonComponent;
